if ($('.afhaak-trigger-js').length !== 0) {
    jQuery(document).ready(function($) {

        var canPlaceCreditApplication = false;
        var optionCounter = $('.afhaak_option').length / 2;

        if(optionCounter == 0)
            optionCounter = 1;

        $('#header').css('margin-bottom', '0px');
        $('#content').css('padding-top', '0px');

        function checkOptions(){

            $.ajax({
                url: '/ajax/checkConditions/',
                type: 'GET',
                dataType: 'json',
                data: $('form').serialize(),
                success: function(data)
                {
                    canPlaceCreditApplication = data;
                    toggleMessage();
                    chosenCounter = 0;

                    $('.afhaak_option:checked').each(function(index, el) {

                        chosenCounter++;

                    });

                    if(canPlaceCreditApplication && chosenCounter === optionCounter){
                        $('.get-offer').show();

                        $.ajax({
                            url: '/ajax/unsetSession',
                            type: 'get',
                            data: {sessionName: 'afhaak_trigger'},
                        });

                    }else{
                        $('.get-offer').hide();
                    }
                }
            });
        };

        function toggleMessage(){
            chosenCounter = 0;

            $('.afhaak_option:checked').each(function(index, el) {

                chosenCounter++;

            });

            if(chosenCounter === optionCounter && canPlaceCreditApplication)
            {
                $('.success').show();
                $('.error').hide();
            }else if(chosenCounter === optionCounter && !canPlaceCreditApplication)
            {
                $('.success').hide();
                $('.error').show();
            }else{
                $('.success').hide();
                $('.error').hide();
            }
        }

        $('.afhaak_option').on('click', function(){
            checkOptions();
        });

        checkOptions();
        toggleMessage();

    });
}